import * as React from 'react'
import RowItem from './row_item'
import { ItemBoxType } from './item_types'

const { I18n } = window as any

type SourceBoxProps = {
  items: ItemBoxType[]
  selectItem: (item: any) => void
  selectAll: () => void
  showRegions?: boolean
}
export default function SourceBox(props: SourceBoxProps) {
  const { items, selectItem, selectAll, showRegions } = props
  return (
    <table className="table table-bordered table-hover table-striped table-sm">
      <thead className="">
        <tr>
          <th>{I18n.t('activerecord.attributes.elements/base_element.location_number')}</th>
          <th>
            {I18n.t('activerecord.models.location.other')} ({items.length})
          </th>
          {showRegions && <th className="w-30">{I18n.t('activerecord.models.regions/region.one')}</th>}
          <th>{I18n.t('activerecord.attributes.elements/base_element.location_address')}</th>
          <th className="w-20">
            <a onClick={selectAll} className="action-control">
              {I18n.t('application.actions.select_all')}
              &nbsp;
              <i className="fa fa-angle-double-right" />
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        {items.map((item) => (
          <RowItem item={item} key={`item-key-${item.id}`} action={selectItem} showRegions={showRegions} />
        ))}
      </tbody>
    </table>
  )
}
